import { APIs } from "../api/api";
import axios from "axios";

export const confirmPayment = (payload) => {
  const userData = JSON.parse(localStorage.getItem("_2mseamlessTailoring"));
  let user = userData?.user;
  let token = userData?.token;

  const headers = {
    email: user?.email ?? "",
    authorization: token ?? "",
  };

  const { id, ref } = payload;
  return axios
    .get(`${APIs.PAYMENT.CONFIRM_PAYMENT}?&ref=${ref}`, {headers: { ...headers }})
    .then((res) => {
      return res;
    });
};

// .get(`${APIs.PAYMENT.CONFIRM_PAYMENT}?id=${id}&ref=${ref}`)
